import { useState } from "react";
import PagePadding from "../layouts/PagePadding";
import Input from "../components/form-input/Input";
import Btn from "../components/btn/create-account/Btn";
import Outer from "../layouts/form/Outer";
import Inner from "../layouts/form/Inner";
import Footer from "../components/onboarding/Footer";
import { handleDisable } from "../utils/btn/handleDisable";
import { useNavigate } from "react-router-dom";
import req from "../axios/interceptedAxiosInstance";
import useAuth from "../hooks/useAuth";
import IsLoading from "../components/loading/IsLoading";
import { errorToast, successToast } from "../notification/notification";

const Verify = ({ setLoading }) => {
  const [code, setCode] = useState("");

  const { user } = useAuth();

  const navigate = useNavigate();

  const verifyBody = {
    email: user.email,
    code: code,
  };

  const resendBody = {
    email: user.email,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await req.post("auth/verify-code", verifyBody);
      const msg = response?.data?.message;
      if (msg.includes("Invalid Verification")) {
        errorToast(msg);
        setLoading(false);
      } else {
        successToast(msg);
        navigate("/sign-in");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleResend = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await req.post("auth/resend-code", resendBody);
      successToast(response?.data?.message);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  let disable = handleDisable([code]);

  return (
    <div className="relative">
      <PagePadding>
        <Outer>
          <Inner>
            <div className="mt-4 flex w-fit gap-14 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left cursor-pointer"
                viewBox="0 0 16 16"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <h4 className="font-normal text-2xl">Verify Email Address</h4>
            </div>
            <p className="font-normal text-center text-base mt-6">
              {`Please enter the 6 digit code we sent to ${user.email}`}
            </p>

            <form className="mt-5">
              <Input
                type="text"
                placeholder="Code"
                value={code}
                onValueChange={setCode}
                required={true}
              />
              <div>
                <Btn
                  innerText="Continue"
                  inactive="bg-darkGrey"
                  active="bg-logoRed"
                  disable={disable}
                  onclick={handleSubmit}
                />
              </div>
              <div>
                <Btn
                  innerText="Resend OTP"
                  active="bg-white-500"
                  border="border border-solid border-darkGrey"
                  disable={false}
                  onclick={handleResend}
                />
              </div>
            </form>
          </Inner>
        </Outer>
      </PagePadding>
      <Footer />
    </div>
  );
};

export default IsLoading(Verify, "Verifying your email");
